<template>
  <div class="infinite-scroll">
    <slot></slot>
    <div v-if="loading" class="loading-text">
        <slot name="loading">Loading...</slot>
    </div>
    <div v-if="isEnd" class="loading-text">
        <slot name="loading">{{ text }}</slot>
    </div>
    <div class="observe-el"></div>
  </div>
</template>

<script>
/**
 * @description infinite-scroll要有固定高度。默认为100%，可自行css覆盖。
 */
export default {
  props: {
    load: {
      type: Function,
    },
    isFirstLoad: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEnd: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: 'No More Comics...',
    },
    disable: {

    },
  },
  data() {
    return {
      isFirst: true,
    };
  },
  mounted() {
    const el = document.querySelector('.observe-el');
    if (el) {
      const ob = new IntersectionObserver(this.intersectionCallback);
      ob.observe(el);
    }
  },
  methods: {
    intersectionCallback(entries) {
      const entry = entries[0];
      if (!this.isFirstLoad && this.isFirst) {
        this.isFirst = false;
        return;
      }
      if (this.isEnd) return;
      if (this.loading) return;
      if (!entry) return;
      if (!entry.isIntersecting) return; // 隐藏不执行
      this.load && this.load.call(this.$parent);
    },
  },
};
</script>

<style lang="less">
.infinite-scroll {
    height: 100%;
    overflow-y: scroll;
    .loading-text {
        text-align: center;
        font-size: @fontSmall;
        color: @gray;
    }
    .observe-el {
        height: 5px;
    }
}

</style>
